import $ from 'jquery';
import categoriesMenu from '@/modules/navigations/categories-menu';
import { bindJQuery } from '@/scripts/helpers/library';
import { accordion } from '../modules/containers/accordion/index';
import { detectBrowser } from '@/scripts/helpers/detectBrowser';

$(document).ready(() => {
  categoriesMenu();
  accordion();
  bindJQuery();
  detectBrowser();
});
